const byCountry = {
  AU: {
    address1: {},
    suburb: { eitherAlternative: "city" },
    city: { eitherAlternative: "suburb" },
    state: {
      required: true,
    },
    zipCode: {
      required: true,
    },
  },
  BE: {
    address1: {},
    city: {
      required: true,
    },
    state: { fmsKey: "state", countryKey: "region" },
    region: { fmsKey: "state", countryKey: "region" },
    county: { fmsKey: "county", countryKey: "province" },
    province: { fmsKey: "county", countryKey: "province" },
    zipCode: {
      required: true,
    },
  },
  CA: {
    address1: {},
    city: {
      required: true,
    },
    state: {
      fmsKey: "state",
      countryKey: "province",
      required: true
    },
    province: {
      fmsKey: "state",
      countryKey: "province",
      required: true
    },
    zipCode: {},
  },
  DE: {
    address1: {},
    city: {
      required: true,
    },
    state: { required: true },
    county: { },
    zipCode: {
      required: true,
    },
  },
  ES: {
    address1: {},
    city: {
      required: true,
    },
    state: { fmsKey: "state", countryKey: "community" },
    community: { fmsKey: "state", countryKey: "community" },
    county: { fmsKey: "county", countryKey: "province" },
    province: { fmsKey: "county", countryKey: "province" },
    zipCode: {
      required: true,
    },
  },
  FR: {
    address1: {},
    city: {
      required: true,
    },
    state: { fmsKey: "state", countryKey: "region" },
    region: { fmsKey: "state", countryKey: "region" },
    county: { fmsKey: "county", countryKey: "department" },
    department: { fmsKey: "county", countryKey: "department" },
    zipCode: {
      required: true,
    },
  },
  GB: {
    address1: {},
    city: {
      required: true,
    },
    state: {},
    county: {},
    zipCode: {
      required: true,
    },
  },
  IT: {
    address1: {},
    city: {
      required: true,
    },
    state: { fmsKey: "state", countryKey: "region" },
    region: { fmsKey: "state", countryKey: "region" },
    county: { fmsKey: "county", countryKey: "province" },
    province: { fmsKey: "county", countryKey: "province" },
    zipCode: {
      required: true,
    },
  },
  NL: {
    address1: {},
    city: {
      required: true,
    },
    state: { fmsKey: "state", countryKey: "province" },
    province: { fmsKey: "state", countryKey: "province" },
    zipCode: {
      // in the Caribbean Netherlands, there is no zip code
      required: false,
    },
  },
  US: {
    address1: {},
    city: {
      required: true,
    },
    state: {
      required: true,
    },
    zipCode: {},
  },
};

exports.byCountry = byCountry;
